<template>
  <div v-if="!isLoading">
    <search-item
      v-for="(result, index) in results"
      :key="index"
      :data="result"
      :term="term" />

    <b-pagination
      :total="pagination.total"
      :current.sync="pagination.current"
      :per-page="pagination.perPage"
      order="is-centered" />
  </div>
  <loading-content v-else />
</template>

<script>
import API from '@/api'
import SearchItem from '@/components/SearchItem'
import LoadingContent from '@/components/LoadingContent'

export default {
  name: 'ArticleSearchResults',
  props: { term: String },
  components: {
    SearchItem,
    LoadingContent
  },
  data () {
    return {
      isLoading: true,
      results: [],
      pagination: {
        total: 0,
        current: 1,
        perPage: 10
      }
    }
  },
  mounted () {
    this.fetchResults()
  },
  watch: {
    term () {
      // Retorna para a primeira página
      this.pagination.current = 1
      this.fetchResults()
    },
    // Atualiza a listagem sempre que a página (paginação) for alterada.
    'pagination.current' () {
      this.fetchResults()
      window.scrollTo(0, 0)
    }
  },
  methods: {
    fetchResults () {
      this.isLoading = true

      const params = {
        search: this.term,
        take: this.pagination.perPage,
        page: this.pagination.current
      }

      API.articles.index(params, (results, pagination) => {
        // Resultado
        this.results = results

        // Paginação
        this.pagination.total = pagination.total
        this.pagination.perPage = pagination.per_page
        this.pagination.current = pagination.current_page

        this.isLoading = false
      })
    }
  }
}
</script>
